import React from 'react'
import EquipmentHero from "./EquipmentHero"
import AllEquipments from "./AllEquipments"



const EquipmentPage = () => {
  return (
    <>
      <EquipmentHero />
      <AllEquipments />
    </>
  )
}



export default EquipmentPage